//Icons
export { default as BagIcon } from './BagIcon'
export { default as BoxIcon } from './Box'
export { default as BoxUpright } from './BoxUpright'
export { default as Calendar } from './Calendar'
export { default as CardIcon } from './cards/CardIcon'
export { default as Chevron } from './Chevron'
export { default as Clothesline } from './Clothesline'
export { default as Cloud } from './Cloud'
export { default as CloudGroup } from './CloudGroup'
export { default as GuaranteeIcon } from './GuaranteeIcon'
export { default as MailboxIcon } from './MailboxIcon'
export { default as Pencil } from './Pencil'
export { default as Phone } from './Phone'
export { default as PressIcon } from './press/PressIcon'
export { default as Ruler } from './Ruler'
export { default as SearchIcon } from './SearchIcon'
export { default as XIcon } from './XIcon'
export { default as InfoIcon } from './InfoIcon'
export * from './AIcon'
export * from './Checkmark'
export * from './CircleChevron'
export * from './Close'
export * from './Hamburger'
export * from './Highlighter'
export * from './Logo'
export * from './Spinner'



// WEBPACK FOOTER //
// ./src/core/icons/index.js